import { render, staticRenderFns } from "./zhjy.vue?vue&type=template&id=5a349d87&scoped=true&"
import script from "./zhjy.vue?vue&type=script&lang=js&"
export * from "./zhjy.vue?vue&type=script&lang=js&"
import style0 from "./zhjy.vue?vue&type=style&index=0&id=5a349d87&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a349d87",
  null
  
)

export default component.exports